import React from "react";
import Alert from "Components/DesignSystem/Alert/Alert";
import Spinner from "Components/DesignSystem/Spinner/Spinner";

/**
 * The Images / Long Description panels' status strip (§ 74). Same contract as always —
 * status decides the surface, message is the text — but on the DS `Alert`/`Spinner`
 * instead of bootstrap `.alert-*` + Font Awesome + the lottie `CompatioLoader` (whose
 * import crashed under jsdom and had to be mocked in every consuming test).
 *
 * `live` because this strip appears in response to a user action (save, load, delete),
 * which is exactly when SC 4.1.3 wants the announcement.
 */
const LoadingSuccessErrorAlert = ({ loading }) => {
  return (
    <>
      {loading.status === "Saving" && (
        <Alert tone="info" live data-testid="panel-status-alert">
          {loading.message}
        </Alert>
      )}
      {loading.status === "Loading" && (
        <div className="tw-flex tw-justify-center tw-py-6">
          <Spinner size="lg" label={loading.message || "Loading"} showLabel data-testid="panel-status-loading" />
        </div>
      )}
      {loading.status === "Error" && (
        <Alert tone="danger" live data-testid="panel-status-alert">
          {loading.message}
        </Alert>
      )}
      {loading.status === "Success" && loading.message !== undefined && (
        <Alert tone="success" live data-testid="panel-status-alert">
          {loading.message}
        </Alert>
      )}
    </>
  );
};
export default LoadingSuccessErrorAlert;
